// 達成条件
const ACHIEVEMENT_CONDITION_MAP: { [id: number] : string } = {
    1:"1回学習しよう",
    2:"全問正解しよう"
}

// 宿題出題単位状態
const HOMEWORK_PROGRESS_QUESTIONSET_STATUS_MAP: { [id: number] : string } = {
    1:"未解答",
    2:"解答中",
    3:"完了"
}

// Homework Progress map
const HOMEWORK_PROGRESS: { [id: string] : number } = {
    NOTSTARTED: 1,
    INPROGRESS: 2,
    COMPLETEDWITHIN: 3,
    COMPLETEDAFTER: 4,
}

// 宿題進捗一覧の状態セレクトボックス選択肢
const HOMEWORK_PROGRESS_STATUS: Array<{name: string, value: number}> = [
    {name: "未着手", value: 1},
    {name: "進行中", value: 2},
    {name: "完了（期限内）", value: 3},
    {name: "完了（期限後）", value: 4},
  ]

// 宿題進捗一覧の状態セレクトボックスに表示するラベル名
const SELECT_STATUS_LABEL_NAME: string =  "進捗でフィルタ"
// 宿題進捗一覧の学級セレクトボックスに表示するラベル名
const SELECT_CLASSROOM_LABEL_NAME: string = "学級でフィルタ"

// Homework Progress QuestionSet
const HOMEWORK_PROGRESS_QUESTIONSET_STATUS: { [id: string] : number } = {
    NOTSTARTED: 1,
    INPROGRESS: 2,
    COMPLETED: 3,
}

const ACHIEVEMENT_CONDITION: Array<{name: string, value: number}> = [
        {name: "正解率は問わない", value: 1},
        {name: "全問正解する", value: 2},
    ]

const HOMEWORK_STATUS: { [id: string] : string } = {
    UNPUBLISHED: "未公開",
    PUBLISHED: "公開中",
    CLOSED: "終了",
}

const INFOTOAST_MESSAGE_PARAMNAME: string = "message"

const HOMEWORK_STATUS_CLASS: {[id:number]:string} = {
    1: "-before",
    2: "-answering",
    3: "-complete",
}

const LIST_HOMEWORK_SELECTBOX_LABEL_NAME = {
    ACADEMIC_SESSION: "年度",
    ACADEMIC_YEAR: "学年",
    CLASSROOM: "学級",
    SUBJECT_FIELD: "教科",
    STATUS: "状態",
} as const

const HOMEWORK_LIST_STATUS = [
    {name: "未公開", value: 1},
    {name: "公開中", value: 2},
    {name: "終了", value: 3},
    {name: "公開中+未公開", value:4}
] as const

export {
    ACHIEVEMENT_CONDITION_MAP,
    HOMEWORK_PROGRESS_QUESTIONSET_STATUS_MAP,
    HOMEWORK_PROGRESS,
    HOMEWORK_PROGRESS_QUESTIONSET_STATUS,
    HOMEWORK_PROGRESS_STATUS,
    SELECT_STATUS_LABEL_NAME,
    SELECT_CLASSROOM_LABEL_NAME,
    ACHIEVEMENT_CONDITION,
    HOMEWORK_STATUS,
    INFOTOAST_MESSAGE_PARAMNAME,
    HOMEWORK_STATUS_CLASS,
    LIST_HOMEWORK_SELECTBOX_LABEL_NAME,
    HOMEWORK_LIST_STATUS
}
